<template>
    <Dialog :open="visible" @update:open="(open: boolean) => { if (!open) noClicked() }">
        <DialogContent>
            <DialogHeader>
                <DialogTitle>{{ modalText }}</DialogTitle>
            </DialogHeader>
            <DialogFooter>
                <Button variant="destructive" @click="noClicked">No</Button>
                <Button @click="yesClicked">Yes</Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useModalStore } from "@/stores/modal";

const modalStore = useModalStore();
const { visible, modalText, yes_cb, no_cb } = storeToRefs(modalStore);

function noClicked() {
	visible.value = false;
	no_cb.value();
}

function yesClicked() {
	visible.value = false;
	yes_cb.value();
}
</script>
